import { handleActions } from 'redux-actions';
import { Actions } from '../constants';

export const initialState = {};

const reducer = handleActions(
  {
    [Actions.SELECT_VARIANT]: (state, { payload: { name, variant } }) => ({
      ...state,
      [name]: variant,
    }),
  },
  initialState,
);

export default reducer;
